/* tslint:disable */
/* eslint-disable */
/**
 * Compliance
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


import { mapValues } from '../runtime';
import type { CompanyIdentityCountryCapabilityResource } from './';
import {
    CompanyIdentityCountryCapabilityResourceFromJSON,
    CompanyIdentityCountryCapabilityResourceFromJSONTyped,
    CompanyIdentityCountryCapabilityResourceToJSON,
} from './';

/**
 * Supported countries and, for each, the list of identifier types and a hint of whether a
 * region code is expected. Derived from `CountryCode.registrationNumberMatchers`
 * (`lib-platform/company-validation/.../CountryCode.kt:342`). Countries with no matchers
 * are excluded.
 * 
 * @export
 * @interface CompanyIdentityCapabilitiesResource
 */
export interface CompanyIdentityCapabilitiesResource {
    /**
     * 
     * @type {Array<CompanyIdentityCountryCapabilityResource>}
     * @memberof CompanyIdentityCapabilitiesResource
     */
    countries: Array<CompanyIdentityCountryCapabilityResource>;
}

/**
 * Check if a given object implements the CompanyIdentityCapabilitiesResource interface.
 */
export function instanceOfCompanyIdentityCapabilitiesResource(value: object): value is CompanyIdentityCapabilitiesResource {
    if (!('countries' in value) || value['countries'] === undefined) return false;
    return true;
}

export function CompanyIdentityCapabilitiesResourceFromJSON(json: any): CompanyIdentityCapabilitiesResource {
    return CompanyIdentityCapabilitiesResourceFromJSONTyped(json, false);
}

export function CompanyIdentityCapabilitiesResourceFromJSONTyped(json: any, ignoreDiscriminator: boolean): CompanyIdentityCapabilitiesResource {
    if (json == null) {
        return json;
    }
    return {
        
        'countries': ((json['countries'] as Array<any>).map(CompanyIdentityCountryCapabilityResourceFromJSON)),
    };
}

export function CompanyIdentityCapabilitiesResourceToJSON(value?: CompanyIdentityCapabilitiesResource | null): any {
    if (value == null) {
        return value;
    }
    return {
        
        'countries': ((value['countries'] as Array<any>).map((v) => CompanyIdentityCountryCapabilityResourceToJSON(v))),
    };
}

